import React, { useRef, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import emailjs from "emailjs-com";
import { colors } from "../../style";
import BeatLoader from "react-spinners/BeatLoader";
import "../UI/style.css";

const EmailModal = ({ showModal, setShowModal }) => {
  const [name, setName] = useState("");

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [emptyField, setEmptyField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);

  const form = useRef();

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents default refresh by the browser

    if (name !== "" && email !== "" && message !== "") {
      setEmptyField(false);
      setLoading(true);
      emailjs
        .sendForm(
          process.env.REACT_APP_SERVICE_ID,
          process.env.REACT_APP_TEMPLATE_ID,
          form.current,
          process.env.REACT_APP_USER_ID
        )
        .then(
          (result) => {
            form.current.reset();
            setLoading(false);
            setSuccess(true);
            setEmail("");
            setName("");
            setMessage("");
          },
          (error) => {
            setLoading(false);
            setFailure(true);
          }
        );
    } else {
      setEmptyField(true);
      setSuccess(false);
      setFailure(false);
    }
  };

  return (
    <Modal center open={showModal} onClose={() => setShowModal(!showModal)}>
      <h2 style={{ color: "black" }}>Contact Me</h2>
      <br />
      <br />
      {emptyField && <p style={{ color: "red" }}>please fill all the fields</p>}
      {success && (
        <p style={{ color: "green" }}>
          Thank You! we have received your email.
        </p>
      )}
      {failure && <p style={{ color: "red" }}>Something went wrong</p>}
      <form ref={form} onSubmit={handleSubmit}>
        <h3 style={{ color: "black" }}>Your Name</h3>

        <textarea
          rows="1"
          cols="25"
          className="font-20"
          name="name"
          style={{
            borderRadius: "10px",
            color: "black",
            background: "white",
          }}
          onChange={(e) => setName(e.target.value)}

          /*   placeholder="........." */
        />
        <br />
        <br />
        <h3 style={{ color: "black" }}>Your Email</h3>
        <textarea
          rows="1"
          cols="25"
          className="font-20"
          name="email"
          style={{
            borderRadius: "10px",
            color: "black",
            background: "white",
          }}
          onChange={(e) => setEmail(e.target.value)}
          type="email"

          /*   placeholder="........." */
        />
        <br />
        <br />
        {loading && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <BeatLoader color="dodgerblue" loading={loading} size={15} />
          </div>
        )}

        <h3 style={{ color: "black" }}>Message</h3>
        <textarea
          className="font-20"
          name="message"
          style={{
            borderRadius: "10px",

            color: "black",
            background: "white",
          }}
          onChange={(e) => setMessage(e.target.value)}
          rows="4"
          cols="25"

          /*   placeholder="........." */
        />
        <br />
        <br />

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            style={{
              boxSizing: "border-box",
              padding: "10px 20px",
              background: colors.primaryColor,
              color: "#fff",
              display: "inline-block",
              borderRadius: "20px",
              boxShadow: "dodgerblue 0 0 10px 0px",
              border: "1px solid",
              borderColor: "transparent",
              fontSize: 12,
              letterSpacing: "1px",
            }}
            className="mtb-10 scaleIn"
            label="Send"
            type="submit"
          >
            Send
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EmailModal;
